/**
 * PORTAL COMPONENT - Renders in Mapbox GL popup portals outside React tree
 *
 * ⚠️  DO NOT use hooks that require context (useNavigate, useLocation, useContext, etc.)
 * ⚠️  All dependencies must be passed via props from the parent component
 */
import type { Unit } from '@/types';
import { SmallClusterContent } from './shared/SmallClusterContent';
import { ShareButton } from './shared/ShareButton';

interface SmallClusterPopupProps {
  units: Unit[];
  location: string;
  onUnitHover?: (unit: Unit | null) => void;
  onUnitClick?: (unit: Unit) => void;
  isMobile: boolean;
  initialActiveUnit?: Unit | null;
  navigate: (path: string) => void;
  onClose: () => void;
  getShareableUrl?: () => string;
}

export function SmallClusterPopup({
  units,
  onUnitHover,
  onUnitClick,
  initialActiveUnit,
  navigate,
  onClose,
  getShareableUrl,
}: SmallClusterPopupProps) {

  return (
    <div className="w-[375px] h-[500px] flex flex-col bg-background rounded-lg overflow-hidden shadow-lg border border-border/50 relative group/popup">
      <ShareButton
        className="opacity-0 group-hover/popup:opacity-100 transition-opacity duration-200"
        getShareUrl={getShareableUrl}
      />
      <SmallClusterContent
        units={units}
        isMobile={false} // Always false for desktop popup
        initialActiveUnit={initialActiveUnit || undefined}
        onClose={onClose}
        onUnitClick={onUnitClick}
        onUnitHover={onUnitHover}
        navigate={navigate}
      />
    </div>
  );
}
